import { memo } from 'react'

import { cn } from '@/shared/lib/cn'

import { useFeature } from '../model/useFeature.tsx'
import { FeatureElementProps } from '../types/FeatureElementProps.ts'
import { FeatureButton } from './FeatureButton'
import { FeatureClickableButton } from './FeatureClickableButton'
import { FeatureIcon } from './FeatureIcon.tsx'

export const FeatureElement = memo(
	({
		feature,
		onClick,
		forceIsClickable,
		showSelectedOption = true,
		showFeatureName = true,
		disableIcon = false,
		classNames
	}: FeatureElementProps) => {
		const { label, tooltipInfo, iconValues, title, isClickable, isExist } =
			useFeature(feature, showSelectedOption, showFeatureName, forceIsClickable)

		return (
			<div
				className={cn('relative flex', classNames?.base)}
				title={title}
			>
				{isClickable && (
					<FeatureClickableButton
						classNames={{ base: cn('text-left', classNames?.content) }}
						iconValues={iconValues}
						isExist={isExist}
						onClick={onClick}
						disableIcon={disableIcon}
						data-wwt-id="feature--button"
						tooltipInfo={tooltipInfo}
					>
						{label}
					</FeatureClickableButton>
				)}

				{!isClickable && (
					<div className="flex w-full items-center gap-2 text-gray-500">
						{!disableIcon && (
							<FeatureIcon
								className={cn(
									'min-h-6 min-w-6',
									isExist ? 'text-gray-500' : 'text-brand-100'
								)}
								{...iconValues}
							/>
						)}

						<FeatureButton
							className={cn('text-left', classNames?.content)}
							isExist={isExist}
							iconValues={iconValues}
							tooltipInfo={tooltipInfo}
						>
							{label}
						</FeatureButton>
					</div>
				)}
			</div>
		)
	}
)

FeatureElement.displayName = 'FeatureElement'
